module.exports = __webpack_public_path__ + "static/images/avatar_default.7658dc5.png";